import { Form, Spin, Typography } from "antd/es";
import moment from "moment";
import { connect } from "react-redux";
import {
  Button,
  Email,
  Header,
  HorizontalStack,
  Icon,
  KCol,
  KDatePicker,
  KPanel,
  KRow,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  NumberInput,
  TextArea,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import { KCheckbox, KSelectBox } from "../../kuika";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { YeniProjeGenel_ScreenBase } from "./yeniprojegenel-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class YeniProjeGenel_Screen extends YeniProjeGenel_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{
              yeniprojegenel_480528_value: undefined,
              yeniprojegenel_857613_value:
                this.props.screenInputs.ProjeCategory ??
                this.props.screenInputs.projecategory,
              yeniprojegenel_403147_value: undefined,
              yeniprojegenel_65470_value: undefined,
              yeniprojegenel_150733_value: undefined,
              yeniprojegenel_340144_value: undefined,
              yeniprojegenel_854212_value: undefined,
              yeniprojegenel_821409_value: undefined,
              yeniprojegenel_67994_value: undefined,
              yeniprojegenel_572576_value: undefined,
              yeniprojegenel_205928_value: undefined,
              yeniprojegenel_997091_value: undefined,
              yeniprojegenel_502939_value: undefined,
              yeniprojegenel_550625_value: undefined,
              yeniprojegenel_989743_value: undefined,
              yeniprojegenel_483299_value: undefined,
              yeniprojegenel_403783_value: undefined,
              yeniprojegenel_35817_value: "",
            }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <div
              style={
                {
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "100%",
                } as any
              }
            >
              <Header
                key="-2"
                id="yeniprojegenel_header"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    paddingTop: 0,
                    paddingRight: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "rgba(68, 68, 68, 1)",
                  } as any
                }
              >
                <KRow
                  key="970147"
                  id="970147"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderBottomWidth: 1,
                      borderColor: "#d9e2ec",
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "#eef3f8",
                      paddingTop: 24,
                      paddingRight: 24,
                      paddingBottom: 24,
                      paddingLeft: 24,
                    } as any
                  }
                >
                  <KCol
                    key="730995"
                    id="730995"
                    xs={20}
                    sm={20}
                    md={20}
                    lg={20}
                    xl={20}
                    xxl={20}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        alignItems: "center",
                      } as any
                    }
                  >
                    <HorizontalStack
                      key="444323"
                      id="444323"
                      direction="horizontal"
                      size={12}
                      overflowX="auto"
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <Icon
                        key="336022"
                        id="336022"
                        iconName="add"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontSize: "26px",
                            color: "#7c3aed",
                          } as any
                        }
                      ></Icon>
                      <Label
                        key="301252"
                        id="301252"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          301252,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            fontSize: "16px",
                            color: "#1f2a44",
                          } as any
                        }
                      ></Label>
                    </HorizontalStack>
                  </KCol>
                  <KCol
                    key="649634"
                    id="649634"
                    xs={4}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    xxl={4}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        alignItems: "center",
                        textAlign: "-webkit-right",
                      } as any
                    }
                  >
                    <Icon
                      key="925037"
                      id="925037"
                      onClick={(e?: any) => {
                        if (e && e.stopPropagation) e.stopPropagation();
                        this.YeniProjeGenelComponent_925037_onClick();
                      }}
                      showCursorPointer
                      iconName="close"
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                          display: "inline",
                          fontSize: "26px",
                          color: "#7b8aa0",
                        } as any
                      }
                    ></Icon>
                  </KCol>
                </KRow>
              </Header>
              <div
                key="-1"
                id="yeniprojegenel_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    paddingTop: 24,
                    paddingRight: 24,
                    paddingBottom: 24,
                    paddingLeft: 24,
                    display: "block",
                    fontFamily: "Poppins",
                  } as any
                }
              >
                <KRow
                  key="451877"
                  id="451877"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                    } as any
                  }
                >
                  <KCol
                    key="560827"
                    id="560827"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                      } as any
                    }
                  >
                    <KRow
                      key="102125"
                      id="102125"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 12,
                          paddingRight: 24,
                          paddingBottom: 0,
                          paddingLeft: 24,
                        } as any
                      }
                    >
                      <KCol
                        key="491719"
                        id="491719"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="297322"
                          id="297322"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="713759"
                            id="713759"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              713759,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_480528_value"
                          >
                            <TextInput
                              key="480528"
                              id="480528"
                              kuikaRef={
                                this
                                  .yeniprojegenel_480528_value_kuikaTextInputRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                480528,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              bordered={true}
                              disabled={false}
                              type="text"
                              iconColor="rgba(0, 0, 0, 1)"
                              formatter="None"
                              isCharOnly={false}
                              autoComplete={true}
                              inputMode="all"
                              speechToText={false}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></TextInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="535066"
                        id="535066"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="676419"
                          id="676419"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="988678"
                            id="988678"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              988678,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_857613_value"
                          >
                            <KSelectBox
                              key="857613"
                              id="857613"
                              onChange={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.YeniProjeGenelComponent_857613_onChange();
                              }}
                              editability={this.state.isComp857613Enabled}
                              kuikaRef={
                                this
                                  .yeniprojegenel_857613_value_kuikaAutoCompleteRef
                              }
                              options={this.state.GET_PROJE_KATEGORILERI}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                857613,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              autoClearSearchValue={true}
                              showSearch={true}
                              widthType="fill"
                              containsNullItem={false}
                              sortBy="none"
                              dropdownScrollItemLimit={4}
                              datavaluefield="kategoriKodu"
                              datatextfield="kategoriAdi"
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KSelectBox>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="268057"
                        id="268057"
                        visibility={this.state.isComp268057Visible}
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="504156"
                          id="504156"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="349300"
                            id="349300"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              349300,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_403147_value"
                          >
                            <KSelectBox
                              key="403147"
                              id="403147"
                              kuikaRef={
                                this
                                  .yeniprojegenel_403147_value_kuikaAutoCompleteRef
                              }
                              options={this.state.GET_PROJE_TIPI}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                403147,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              autoClearSearchValue={true}
                              showSearch={true}
                              widthType="fill"
                              containsNullItem={false}
                              sortBy="none"
                              dropdownScrollItemLimit={4}
                              datavaluefield="tipKodu"
                              datatextfield="tipAdi"
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KSelectBox>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="327156"
                        id="327156"
                        visibility={this.state.isComp327156Visible}
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="601132"
                          id="601132"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="222673"
                            id="222673"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              222673,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_65470_value"
                          >
                            <KSelectBox
                              key="65470"
                              id="65470"
                              kuikaRef={
                                this
                                  .yeniprojegenel_65470_value_kuikaAutoCompleteRef
                              }
                              options={this.state.GET_PROJE_TURU}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                65470,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              autoClearSearchValue={true}
                              showSearch={true}
                              widthType="fill"
                              containsNullItem={false}
                              sortBy="none"
                              dropdownScrollItemLimit={4}
                              datavaluefield="turKodu"
                              datatextfield="turAdi"
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KSelectBox>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="201276"
                        id="201276"
                        visibility={this.state.isComp201276Visible}
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="523639"
                          id="523639"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="290269"
                            id="290269"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              290269,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_150733_value"
                          >
                            <NumberInput
                              key="150733"
                              id="150733"
                              decimalSeparator=","
                              disabled={false}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                150733,
                                "placeholder",
                                this.defaultML
                              )}
                              fixedDecimalScale={false}
                              allowNegative={true}
                              allowEmptyFormatting={false}
                              isThousandSeperatorOn={true}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(212, 220, 230, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  color: "rgba(0, 0, 0, 1)",
                                } as any
                              }
                            ></NumberInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="665925"
                        id="665925"
                        visibility={this.state.isComp665925Visible}
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="863349"
                          id="863349"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="606391"
                            id="606391"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              606391,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_340144_value"
                          >
                            <NumberInput
                              key="340144"
                              id="340144"
                              decimalSeparator=","
                              decimalScale={2}
                              disabled={false}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                340144,
                                "placeholder",
                                this.defaultML
                              )}
                              fixedDecimalScale={false}
                              allowNegative={true}
                              allowEmptyFormatting={false}
                              isThousandSeperatorOn={true}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(212, 220, 230, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  color: "rgba(0, 0, 0, 1)",
                                } as any
                              }
                            ></NumberInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="626249"
                        id="626249"
                        visibility={this.state.isComp626249Visible}
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="55333"
                          id="55333"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="61112"
                            id="61112"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              61112,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_854212_value"
                          >
                            <NumberInput
                              key="854212"
                              id="854212"
                              decimalSeparator=","
                              decimalScale={2}
                              disabled={false}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                854212,
                                "placeholder",
                                this.defaultML
                              )}
                              fixedDecimalScale={false}
                              allowNegative={true}
                              allowEmptyFormatting={false}
                              isThousandSeperatorOn={true}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(212, 220, 230, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  color: "rgba(0, 0, 0, 1)",
                                } as any
                              }
                            ></NumberInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="228157"
                        id="228157"
                        visibility={this.state.isComp228157Visible}
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="529815"
                          id="529815"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="830247"
                            id="830247"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              830247,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_821409_value"
                          >
                            <NumberInput
                              key="821409"
                              id="821409"
                              decimalSeparator=","
                              decimalScale={2}
                              disabled={false}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                821409,
                                "placeholder",
                                this.defaultML
                              )}
                              fixedDecimalScale={false}
                              allowNegative={true}
                              allowEmptyFormatting={false}
                              isThousandSeperatorOn={true}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(212, 220, 230, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  color: "rgba(0, 0, 0, 1)",
                                } as any
                              }
                            ></NumberInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="87918"
                        id="87918"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="239834"
                          id="239834"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="903434"
                            id="903434"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              903434,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_67994_value"
                          >
                            <TextInput
                              key="67994"
                              id="67994"
                              kuikaRef={
                                this
                                  .yeniprojegenel_67994_value_kuikaTextInputRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                67994,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              bordered={true}
                              disabled={false}
                              type="text"
                              iconColor="rgba(0, 0, 0, 1)"
                              formatter="None"
                              isCharOnly={false}
                              autoComplete={true}
                              inputMode="all"
                              speechToText={false}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></TextInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                    </KRow>
                    <KRow
                      key="686073"
                      id="686073"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 10,
                          paddingRight: 24,
                          paddingBottom: 0,
                          paddingLeft: 24,
                        } as any
                      }
                    >
                      <KCol
                        key="620398"
                        id="620398"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="852955"
                          id="852955"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="320806"
                            id="320806"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              320806,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_572576_value"
                          >
                            <TextInput
                              key="572576"
                              id="572576"
                              kuikaRef={
                                this
                                  .yeniprojegenel_572576_value_kuikaTextInputRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                572576,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              bordered={true}
                              disabled={false}
                              type="text"
                              iconColor="rgba(0, 0, 0, 1)"
                              formatter="None"
                              isCharOnly={false}
                              autoComplete={true}
                              inputMode="all"
                              speechToText={false}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></TextInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="817592"
                        id="817592"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="350727"
                          id="350727"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="983516"
                            id="983516"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              983516,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_205928_value"
                          >
                            <TextInput
                              key="205928"
                              id="205928"
                              kuikaRef={
                                this
                                  .yeniprojegenel_205928_value_kuikaTextInputRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                205928,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              bordered={true}
                              disabled={false}
                              type="text"
                              iconColor="rgba(0, 0, 0, 1)"
                              formatter="None"
                              isCharOnly={false}
                              autoComplete={true}
                              inputMode="all"
                              speechToText={false}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></TextInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="8623"
                        id="8623"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="987717"
                          id="987717"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="670479"
                            id="670479"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              670479,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_997091_value"
                          >
                            <Email
                              key="997091"
                              id="997091"
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                997091,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              disabled={false}
                              iconColor="rgba(0, 0, 0, 1)"
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></Email>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                    </KRow>
                    <KRow
                      key="695956"
                      id="695956"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 10,
                          paddingRight: 24,
                          paddingBottom: 0,
                          paddingLeft: 24,
                        } as any
                      }
                    >
                      <KCol
                        key="601400"
                        id="601400"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="918874"
                          id="918874"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="908253"
                            id="908253"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              908253,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_502939_value"
                          >
                            <KDatePicker
                              key="502939"
                              id="502939"
                              kuikaRef={
                                this.yeniprojegenel_502939_value_kuikaDateRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                502939,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              format="DD/MM/YYYY"
                              displayType="date"
                              returnDisplayValue={false}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KDatePicker>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="849612"
                        id="849612"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="878184"
                          id="878184"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="825970"
                            id="825970"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              825970,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_550625_value"
                          >
                            <KDatePicker
                              key="550625"
                              id="550625"
                              kuikaRef={
                                this.yeniprojegenel_550625_value_kuikaDateRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                550625,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              format="DD/MM/YYYY"
                              disableBeforeDate={moment().format(
                                "YYYY-MM-DDTHH:mm:ss"
                              )}
                              displayType="date"
                              returnDisplayValue={false}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KDatePicker>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                      <KCol
                        key="293575"
                        id="293575"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="400132"
                          id="400132"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="704278"
                            id="704278"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              704278,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            friendlyName="Bütçe (₺) Label"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_989743_value"
                          >
                            <NumberInput
                              key="989743"
                              id="989743"
                              decimalSeparator=","
                              decimalScale={2}
                              disabled={false}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                989743,
                                "placeholder",
                                this.defaultML
                              )}
                              fixedDecimalScale={false}
                              allowNegative={true}
                              allowEmptyFormatting={false}
                              isThousandSeperatorOn={true}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 10,
                                  paddingRight: 12,
                                  paddingBottom: 10,
                                  paddingLeft: 12,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></NumberInput>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                    </KRow>
                    <KRow
                      key="288189"
                      id="288189"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 10,
                          paddingRight: 24,
                          paddingBottom: 0,
                          paddingLeft: 24,
                        } as any
                      }
                    >
                      <KCol
                        key="384642"
                        id="384642"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="88469"
                          id="88469"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="417222"
                            id="417222"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              417222,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_483299_value"
                          >
                            <KSelectBox
                              key="483299"
                              id="483299"
                              kuikaRef={
                                this
                                  .yeniprojegenel_483299_value_kuikaSelectBoxRef
                              }
                              options={this.state.GET_PROJEYONETICI_USERS}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                483299,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              autoClearSearchValue={true}
                              showSearch={false}
                              widthType="fill"
                              containsNullItem={false}
                              sortBy="none"
                              options={this.state.dataSource_483299}
                              datavaluefield="kuserid"
                              datatextfield="firstname"
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 12,
                                  paddingRight: 14,
                                  paddingBottom: 12,
                                  paddingLeft: 14,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KSelectBox>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                    </KRow>
                    <KRow
                      key="489412"
                      id="489412"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 10,
                          paddingRight: 24,
                          paddingBottom: 0,
                          paddingLeft: 24,
                        } as any
                      }
                    >
                      <KCol
                        key="523917"
                        id="523917"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="220328"
                          id="220328"
                          direction="vertical"
                          size={4}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="632061"
                            id="632061"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              632061,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#24344d",
                              } as any
                            }
                          ></Label>
                          <Form.Item
                            className="kFormItem"
                            name="yeniprojegenel_403783_value"
                          >
                            <TextArea
                              key="403783"
                              id="403783"
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                403783,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              autoSize={false}
                              showCount={false}
                              formatter="None"
                              readOnly={false}
                              speechToText={false}
                              style={
                                {
                                  borderTopLeftRadius: 10,
                                  borderTopRightRadius: 10,
                                  borderBottomRightRadius: 10,
                                  borderBottomLeftRadius: 10,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "#d4dce6",
                                  borderStyle: "solid",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 14,
                                  paddingRight: 14,
                                  paddingBottom: 14,
                                  paddingLeft: 14,
                                  minHeight: "92px",
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  color: "#1f2a44",
                                  lineHeight: "22px",
                                } as any
                              }
                            ></TextArea>
                          </Form.Item>
                        </VerticalStack>
                      </KCol>
                    </KRow>
                    <KRow
                      key="60448"
                      id="60448"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 10,
                          paddingRight: 24,
                          paddingBottom: 10,
                          paddingLeft: 24,
                        } as any
                      }
                    >
                      <KCol
                        key="738558"
                        id="738558"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <VerticalStack
                          key="856243"
                          id="856243"
                          direction="vertical"
                          size={18}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <VerticalStack
                            key="757627"
                            id="757627"
                            direction="vertical"
                            size={4}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Label
                              key="384372"
                              id="384372"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                384372,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#24344d",
                                } as any
                              }
                            ></Label>
                            <Form.Item
                              className="kFormItem"
                              name="yeniprojegenel_35817_value"
                            >
                              <TextArea
                                key="35817"
                                id="35817"
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  35817,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                autoSize={false}
                                showCount={false}
                                formatter="None"
                                readOnly={false}
                                speechToText={false}
                                style={
                                  {
                                    borderTopLeftRadius: 10,
                                    borderTopRightRadius: 10,
                                    borderBottomRightRadius: 10,
                                    borderBottomLeftRadius: 10,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "#d4dce6",
                                    borderStyle: "solid",
                                    backgroundColor: "#ffffff",
                                    paddingTop: 14,
                                    paddingRight: 14,
                                    paddingBottom: 14,
                                    paddingLeft: 14,
                                    minHeight: "120px",
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                    color: "#1f2a44",
                                    lineHeight: "22px",
                                  } as any
                                }
                              ></TextArea>
                            </Form.Item>
                          </VerticalStack>
                          <KPanel
                            key="199351"
                            id="199351"
                            scrolling="hidden"
                            scrollRadius={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                              } as any
                            }
                          >
                            <KRow
                              key="867687"
                              id="867687"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 4,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                } as any
                              }
                            >
                              <KCol
                                key="421099"
                                id="421099"
                                xs={24}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-right",
                                  } as any
                                }
                              >
                                <HorizontalStack
                                  key="684983"
                                  id="684983"
                                  direction="horizontal"
                                  size={12}
                                  overflowX="auto"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Button
                                    key="896270"
                                    id="896270"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.YeniProjeGenelComponent_896270_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      896270,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 10,
                                        borderTopRightRadius: 10,
                                        borderBottomRightRadius: 10,
                                        borderBottomLeftRadius: 10,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "#d4dce6",
                                        borderStyle: "solid",
                                        backgroundColor: "#ffffff",
                                        paddingTop: 6,
                                        paddingRight: 10,
                                        paddingBottom: 6,
                                        paddingLeft: 10,
                                        fontFamily: "Poppins",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        color: "#5b6b82",
                                        lineHeight: "20px",
                                      } as any
                                    }
                                  ></Button>
                                  <Button
                                    key="154680"
                                    id="154680"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.YeniProjeGenelComponent_154680_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      154680,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 10,
                                        borderTopRightRadius: 10,
                                        borderBottomRightRadius: 10,
                                        borderBottomLeftRadius: 10,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "#d4dce6",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(225, 60, 57, 0.64)",
                                        paddingTop: 6,
                                        paddingRight: 10,
                                        paddingBottom: 6,
                                        paddingLeft: 10,
                                        fontFamily: "Poppins",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        color: "rgba(255, 255, 255, 1)",
                                        lineHeight: "20px",
                                      } as any
                                    }
                                  ></Button>
                                  <Button
                                    key="163762"
                                    id="163762"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.YeniProjeGenelComponent_163762_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      163762,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 10,
                                        borderTopRightRadius: 10,
                                        borderBottomRightRadius: 10,
                                        borderBottomLeftRadius: 10,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "#7c3aed",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(13, 150, 212, 1)",
                                        paddingTop: 6,
                                        paddingRight: 10,
                                        paddingBottom: 6,
                                        paddingLeft: 10,
                                        fontFamily: "Poppins",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        color: "#ffffff",
                                        lineHeight: "20px",
                                      } as any
                                    }
                                  ></Button>
                                </HorizontalStack>
                              </KCol>
                            </KRow>
                          </KPanel>
                          <VerticalStack
                            key="867537"
                            id="867537"
                            direction="vertical"
                            size={12}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Label
                              key="351112"
                              id="351112"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                351112,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 700,
                                  fontSize: "15px",
                                  color: "#1f2a44",
                                } as any
                              }
                            ></Label>
                            <KTable
                              key="214215"
                              id="214215"
                              kuikaRef={
                                this.yeniprojegenel_214215_value_kuikaTableRef
                              }
                              form={this.props.form}
                              dataSource={this.state.GetProjeAsamalari}
                              size="middle"
                              bordered={true}
                              loading={false}
                              rowKey="id"
                              transformedOnMobileResolution={false}
                              hideHeaderOnMobileResolution={false}
                              showHeader={false}
                              fixedHeader={false}
                              tableWidthMode="fit"
                              editable={false}
                              editableAlwaysActive={false}
                              insertRowActive={false}
                              insertRowPosition="top"
                              globalSearch={false}
                              searchable={false}
                              shouldSearchOnChange={true}
                              searchDelay={200}
                              sorter={false}
                              filtering={false}
                              resizableColumns={false}
                              pagination={false}
                              pageSize={10}
                              showSizeChanger={false}
                              paginationSelectedTextColor="#246eff"
                              paginationUnselectedTextColor="#000"
                              columnChooser={false}
                              striped={false}
                              stripedColor="#F5F7FA"
                              rowHoverBgColor="#fafafa"
                              showNoDataFound={true}
                              nodatafoundmessage={ReactSystemFunctions.translate(
                                this.ml,
                                214215,
                                "nodatafoundmessage",
                                this.defaultML
                              )}
                              multiSelect={false}
                              multiSelectScope="page"
                              export={false}
                              showRowNumbers={false}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTableHeader
                                key="944319"
                                id="944319"
                                hideOnMobileResolution={false}
                                textDirection="Default"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    color: "rgba(155, 155, 155, 1)",
                                    lineHeight: "20px",
                                  } as any
                                }
                              ></KTableHeader>
                              <KTableRow
                                key="798319"
                                id="798319"
                                hoverFontColor="red"
                                hoverBgColor="#F5F5F5"
                                style={
                                  {
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KTableColumn
                                  key="685315"
                                  id="685315"
                                  title={ReactSystemFunctions.translate(
                                    this.ml,
                                    685315,
                                    "title",
                                    this.defaultML
                                  )}
                                  alwaysVisibleOnMobileResolution={false}
                                  hideFiltering={false}
                                  hideSorting={false}
                                  hideSearch={false}
                                  footerOptions="none"
                                  footerFontSize={14}
                                  footerFontColor="rgb(68, 68, 68)"
                                  excludeFromExport={false}
                                  footerFontWeight="Regular"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KPanel
                                    key="113537"
                                    id="113537"
                                    scrolling="hidden"
                                    scrollRadius={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "#e2e8f0",
                                        backgroundColor: "#eef3f8",
                                        paddingTop: 18,
                                        paddingRight: 16,
                                        paddingBottom: 18,
                                        paddingLeft: 16,
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="109449"
                                      id="109449"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="950286"
                                        id="950286"
                                        xs={24}
                                        sm={2}
                                        md={2}
                                        lg={2}
                                        xl={1}
                                        xxl={1}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            alignItems: "center",
                                          } as any
                                        }
                                      >
                                        <Form.Item
                                          className="kFormItem"
                                          name="yeniprojegenel_447757_checked"
                                        >
                                          <KCheckbox
                                            key="447757"
                                            id="447757"
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              447757,
                                              "label",
                                              this.defaultML
                                            )}
                                            children={ReactSystemFunctions.translate(
                                              this.ml,
                                              447757,
                                              "children",
                                              this.defaultML
                                            )}
                                            disabled={false}
                                            checked={false}
                                            indeterminate={false}
                                            autoFocus={false}
                                            boxColor="#ffffff"
                                            boxColorOnChecked="#246dff"
                                            checkIconColor="#ffffff"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 4,
                                                paddingRight: 4,
                                                paddingBottom: 4,
                                                paddingLeft: 4,
                                                fontFamily: "Montserrat",
                                                fontWeight: 500,
                                                fontSize: "10px",
                                                color: "rgba(1, 1, 1, 1)",
                                              } as any
                                            }
                                          ></KCheckbox>
                                        </Form.Item>
                                      </KCol>
                                      <KCol
                                        key="59377"
                                        id="59377"
                                        xs={24}
                                        sm={10}
                                        md={10}
                                        lg={10}
                                        xl={11}
                                        xxl={11}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            alignItems: "center",
                                          } as any
                                        }
                                      >
                                        <VerticalStack
                                          key="114510"
                                          id="114510"
                                          direction="vertical"
                                          size={4}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="513161"
                                            id="513161"
                                            value="[datafield:asamaAdi]"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "16px",
                                                color: "#0f172a",
                                              } as any
                                            }
                                          ></Label>
                                          <HorizontalStack
                                            key="697095"
                                            id="697095"
                                            direction="horizontal"
                                            size={2}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="740034"
                                              id="740034"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                740034,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 600,
                                                  fontSize: "13px",
                                                  color: "#2563eb",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="333321"
                                              id="333321"
                                              value="[datafield:yuzde]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 600,
                                                  fontSize: "13px",
                                                  color: "#2563eb",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </VerticalStack>
                                      </KCol>
                                      <KCol
                                        key="895723"
                                        id="895723"
                                        xs={24}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        xl={6}
                                        xxl={6}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            alignItems: "center",
                                          } as any
                                        }
                                      >
                                        <Form.Item
                                          className="kFormItem"
                                          name="yeniprojegenel_66343_value"
                                        >
                                          <KDatePicker
                                            key="66343"
                                            id="66343"
                                            kuikaRef={
                                              this
                                                .yeniprojegenel_66343_value_kuikaDateRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              66343,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={true}
                                            format="DD.MM.YYYY"
                                            displayType="date"
                                            returnDisplayValue={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 10,
                                                borderTopRightRadius: 10,
                                                borderBottomRightRadius: 10,
                                                borderBottomLeftRadius: 10,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor: "#d4dce6",
                                                backgroundColor: "#ffffff",
                                                paddingTop: 6,
                                                paddingRight: 10,
                                                paddingBottom: 6,
                                                paddingLeft: 10,
                                                fontFamily: "Poppins",
                                                fontSize: "14px",
                                                color: "#1f2a44",
                                                lineHeight: "20px",
                                              } as any
                                            }
                                          ></KDatePicker>
                                        </Form.Item>
                                      </KCol>
                                      <KCol
                                        key="753087"
                                        id="753087"
                                        xs={24}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        xl={6}
                                        xxl={6}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            alignItems: "center",
                                          } as any
                                        }
                                      >
                                        <Form.Item
                                          className="kFormItem"
                                          name="yeniprojegenel_371229_value"
                                        >
                                          <KDatePicker
                                            key="371229"
                                            id="371229"
                                            kuikaRef={
                                              this
                                                .yeniprojegenel_371229_value_kuikaDateRef
                                            }
                                            placeholder={ReactSystemFunctions.translate(
                                              this.ml,
                                              371229,
                                              "placeholder",
                                              this.defaultML
                                            )}
                                            allowClear={true}
                                            format="DD.MM.YYYY"
                                            displayType="date"
                                            returnDisplayValue={false}
                                            style={
                                              {
                                                borderTopLeftRadius: 10,
                                                borderTopRightRadius: 10,
                                                borderBottomRightRadius: 10,
                                                borderBottomLeftRadius: 10,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor: "#d4dce6",
                                                backgroundColor: "#ffffff",
                                                paddingTop: 6,
                                                paddingRight: 10,
                                                paddingBottom: 6,
                                                paddingLeft: 10,
                                                fontFamily: "Poppins",
                                                fontSize: "14px",
                                                color: "#1f2a44",
                                                lineHeight: "20px",
                                              } as any
                                            }
                                          ></KDatePicker>
                                        </Form.Item>
                                      </KCol>
                                    </KRow>
                                  </KPanel>
                                </KTableColumn>
                              </KTableRow>
                            </KTable>
                          </VerticalStack>
                        </VerticalStack>
                      </KCol>
                    </KRow>
                  </KCol>
                </KRow>
              </div>
            </div>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(YeniProjeGenel_Screen)
        )
      )
    )
  )
);
export { tmp as YeniProjeGenel_Screen };
//export default tmp;
//export { tmp as YeniProjeGenel_Screen };
